import * as React from 'react';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
const icons = { PendingActionsIcon: PendingActionsIcon };

export interface MenuItemType {
  id: string;
  title: string | React.ReactNode;
  caption?: string| React.ReactNode;
  type: string;
  icon?: any;
  children?: MenuItemType[];
  breadcrumbs?: boolean;
  url?: string;
  target?: boolean;
  classes?: string;
  external?: boolean;
  disabled?: boolean;
  chip?:{
    color: "secondary" | "default" | "primary"
    variant?: "outlined" | "filled"
    size?: "small" | "medium"
    label?: React.ReactNode
    avatar?: React.ReactElement
  }
}
const menuItems: { items: MenuItemType[] } = {
  items: [
    {
      id: "dashboard",
      title: "Dashboards",
      type: "group",
      children: [
        {
          id: "pending-claims",
          title: "Pending Claims",
          type: "item",
          url: "/dashboard/pending-claims",
          icon: icons["PendingActionsIcon"],
          breadcrumbs: true,
          } 
      ]
    }   
  ]
  
};
export default menuItems;